import './index.css';
import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Logo } from "./static/repeatTemplate_icon.svg";
import { ReactComponent as LogoModal } from "./static/repeatTemplate_icon_modal.svg";
import { ReactComponent as ArrowCircle } from "./static/arrowCircle.svg";
import { ReactComponent as Arrow } from "./static/arrow.svg";
import { ReactComponent as InfoSVG  } from "./static/Info.svg";
import { ReactComponent as Info } from "./static/repeatTemplateInfo.svg";
import { ReactComponent as RepeatTemplateIcon } from "../../DropDownMenu/SelectRepeatTemplate/static/repeatTemplate_icon.svg"
import DropDown from '../../UIcomponents/DropDown/DropDown';
import ConverterUTC from '../../ConverterUTC/ConverterUTC';
import { useSelector } from 'react-redux';
import ToolTipComponent from '../../UIcomponents/Tooltips/Tooltip';
import { useOutsideClick } from '../../customHooks/useOutsideClick';
import { DropDownListArray, PayloadDropDown } from '../../UIcomponents/DropDown/dropDownType/dropDownType';
import { CustomListItems, ModalCloseWarning, SettingsUserState, TaskGet } from '../../Types/Types';
import InputSelect from '../../UIcomponents/InputSelect/InputSelect';
import Deadlineinput from '../SelectDateCalendar/DeadlineInput/Deadlineinput';
import CustomList from '../../UIcomponents/Lists/CustomList';
import Button from '../../UIcomponents/Button/Button';
import CalendarDotted from '../../UIcomponents/Calendar/Dotted/CalendarDotted';
import ModalWindow from '../../ModalWindow/ModalWindow/ModalWindow';
import DropDownSelectOfDate from '../SelectDateCalendar/SelectDateCalendar';
import OneMonthCalendar from '../../UIcomponents/Calendar/OneMonth/OneMonth';
import { CalendarDottedType } from '../../UIcomponents/Calendar/Dotted/Types/CalendarDottedType';
import differenceOfObjects, { DataObject } from '../../utils/getDifferenceOfObjects';
import { modalWindowContext } from '../../Context/modalWindowContext';
import ModalWindowSaveChanges from '../../ModalWindow/ModalWindowSaveChanges';
import getDateObject from '../../utils/getDateObject';

export type repeatTemlateTask = {
    repitPeriod: number,
    templateTime: string,
    intervalType: number,
    interval: 0,
    selectedWeekDays: string,
    selectedMonthDays: string,
    endType: number,
    dateEnd: string,
    repitCount: number,
    isCreatedAfterCompited: boolean
}

interface DDSelectRepeatTemplateProps {
    datePayload: Date | null,
    onSelectDay: Function,
    updateTemplate: Function,
    templateData: TaskGet,
    viewVariant: 'default' | 'EditTask' | 'repeatTemplate';
    alertNullPeriod?: boolean,
    setAlertNullPeriod?: Function,
    alertNullPeriodIcon?: boolean
    setAlertNullPeriodIcon?: Function
    scroll?: Function
}

function DDSelectRepeatTemplate({datePayload, onSelectDay, updateTemplate, templateData, viewVariant, alertNullPeriod, 
    setAlertNullPeriod, alertNullPeriodIcon, setAlertNullPeriodIcon, scroll}:DDSelectRepeatTemplateProps) {
    const [isActive, setIsActive] = useState<boolean>(false);
    const [isOpenWarning, setIsOpenWarning] = useState<boolean>(false);
    const [initialState, setInitialState] = useState<TaskGet>(templateData);
    const [periodIsPicked, setPeriodIsPicked] = useState<boolean>(false);
    const [pickedOption, setPickedOption] = useState<number | null>(null);
    const [detailedConfig, setDetailedConfig] = useState<boolean>(false);
    const settingsUser = useSelector((state: SettingsUserState) => state.settings.settings);
    const [dateNow, setDateNow] = useState<Date>(new Date());
    const data = new Date();
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [isActiveIntervalPick, setIsActiveIntervalPick] = useState<boolean>(false);
    const refComponent = useRef(null);
    const [intervalInput, setIntervalInput] = useState<number>(1);
    const [repeatInput, setRepeatInput] = useState<number>(1);
    const refDetailedConfig = useRef(null);
    const [windowScreen, setWindowScreen] = useState(window.screen.width);
    useOutsideClick(refComponent, () => setIsActive(false), isActive);
    useOutsideClick(refDetailedConfig, () => checkChangesBeforeCloseOutside(), detailedConfig);
    const [arrWeekDays, setArrWeekDays] = useState<CalendarDottedType[]>([]);
    const [arrMonthDays, setArrMonthDays] = useState<number[]>(templateData?.selectedMonthDays ? templateData.selectedMonthDays.split(',').map(Number) : []);
    const stylesList = {
        width: windowScreen > 410 ? '303px' : '268px',
        backgroundColor: '#F8C440',
        top: windowScreen > 410 ? '160%' : '75%',
        right: windowScreen > 410 ? null : '25%',
        left: windowScreen > 410 && windowScreen < 992 ? null : windowScreen < 410 ? '0%' : '-100%',
        transform: windowScreen > 410 ? null : 'translateX(20%)'
      }

    const stylesListArrow = {
        top: '-8%',
        left: windowScreen > 410 ? '6%' : null,
        right: windowScreen > 410 ? null : '25.5%'
      }
    const stylesContainer = {
        position: windowScreen > 410 ? null : 'inherit'
    }
    const positionList = {
        right: '0%',
        marginRight: '12px',
        transform: 'translate(0%, 0%)'
    }
    
    const stylesListInfo = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        backgroundColor: '#AC98F6', 
        top: '150%', 
        left: '50%', 
        right: '50%', 
        transform: 'translateX(-50%)'
    }
    const stylesListArrowInfo = {
        top: '-8%', 
        right: '9.5%'
    }
    
    const arrDotted: CalendarDottedType[] = [
        {id: 1, name: 'Пн', isSelected: false}, 
        {id: 2, name: 'Вт', isSelected: false}, 
        {id: 3, name: 'Ср', isSelected: false}, 
        {id: 4, name: 'Чт', isSelected: false}, 
        {id: 5, name: 'Пт', isSelected: false}, 
        {id: 6, name: 'Сб', isSelected: false}, 
        {id: 0, name: 'Вс', isSelected: false}
    ]

    const DDprop = <div style={{display:'flex', alignItems: 'center', gap: '14px', fontSize: '12px', fontWeight: '600', padding: '0px 20px 6px 20px', color: '#232360'}}>
        <RepeatTemplateIcon fill='rgba(35, 35, 96, 1)'/>
        <p>Повторять задачу</p>
    </div>

    const modalData: ModalCloseWarning = {
        data: {
            title: 'Изменение данных',
            description: <p>Вы внесли изменения, но не сохранили их. <b style={{fontWeight: 600}}>Сохранить?</b></p>,
            buttons: {
                btnAccept: {
                    title: 'Сохранить',
                    onClickFunc: () => {setIsOpenWarning(false)
                    setDetailedConfig(false)
                    setInitialState(templateData)}
                },
                btnReject : {
                    title: 'Отмена',
                    onClickFunc: () => {declineChanges() 
                        setTimeout(() => {
                            setIsOpenWarning(false)
                        }, 300);}
                }
            }
        }
    }

    useEffect(() => {
        const handleUpdateScreenWidth = () => {
          setWindowScreen(window.screen.width)
        }
    
        window.addEventListener('resize', handleUpdateScreenWidth);
    
        return () => {
          window.removeEventListener('resize', handleUpdateScreenWidth);
        };
      }, [windowScreen])
      
    useEffect(() => {
        if (settingsUser) {
            setDateNow(ConverterUTC({method: 'object',  settingsUser: settingsUser}) as Date)
        }
    }, [settingsUser])

    const updateIntervalPickedVariant = (payload: PayloadDropDown) => {
        updateTemplate('intervalType', payload.index)
        if (templateData.interval > 1) {
            updateTemplate('interval', 1)
        }        
        switch (payload.index) {
            case 0:
            case 3:
                setArrMonthDays([])
                setArrWeekDays([])
                updateTemplate('selectedWeekDays', '')
                updateTemplate('selectedMonthDays', '')
                break;
            case 1: 
                setArrMonthDays([])
                updateTemplate('selectedMonthDays', '')
                break;
            case 2: 
                setArrWeekDays([])
                updateTemplate('selectedWeekDays', '')
                break;
            default:
                break;
        }
    }


    const updateTemplateEndDate = (payload: string) => {        
        updateTemplate('dateEnd', payload)
        // onSelectDay()
    }
    

    const handleSetPeriod = (payload: PayloadDropDown) => {
        if ((optionArr.length === 5 && payload.index + 1 === 5) || 
        (optionArr.length === 6 && payload.index + 1 === 6)) {
            setDetailedConfig(true)
        }
        setPickedOption(payload.index)
        setIsActive(false)
        setPeriodIsPicked(true)
        setAlertNullPeriod && setAlertNullPeriod(false)
        setAlertNullPeriodIcon && setAlertNullPeriodIcon(false)
        updateTemplate('repitPeriod', payload.index)
        // if (payload.index !== 0) {
        //     updateTemplate('isRepit', true)
        // } else {
        //     updateTemplate('isRepit', false)
        // }
    }

    useEffect(() => {
        if (alertNullPeriod && scroll) {
            scroll()
        }
        // eslint-disable-next-line 
    }, [alertNullPeriod])
    
    const updateTimeTask = (payload: string) => {
        updateTemplate('templateTime', payload)
    }
    
    
    const updateEndTypeVariant = (variant: number) => {
        switch (variant) {
            case 0:
                updateTemplate('repitCount', 1)
                updateTemplate('dateEnd', '')
                break;
            case 1:
                updateTemplate('repitCount', 1)
                updateTemplate('dateEnd', templateData.dateEnd ?? dateNow.toLocaleDateString())
                break;
            case 2:
                updateTemplate('dateEnd', '')
                break;
            default:
                break;
        }
        updateTemplate('endType', variant)
    }

    const handleSelectedWeekDays = (weekDays: CalendarDottedType[]) => {
        setArrWeekDays(weekDays)        
        updateTemplate('selectedWeekDays', weekDays.map(el => el.id).join(', '))
    }

    const handleSelectedMonthDays = (monthDays: number[]) => {
        setArrMonthDays(monthDays)
        updateTemplate('selectedMonthDays', monthDays.join(', '))
    }
    
    
    const checkChangesBeforeCloseOutside = () => {
        const differrences: DataObject | undefined = differenceOfObjects({ originalObj: templateData, mutableObj: initialState, returnAnswer: 'object' })
        if ((differrences !== undefined) && (Object.keys(differrences).length > 0)) {
            if ((Object.keys(differrences).length === 1) && ((Object.hasOwn(differrences, 'repitPeriod')) && differrences['repitPeriod'].after !== 5)) {
                setDetailedConfig(false)        
            } else if ((Object.keys(differrences).length >= 1) && ((Object.hasOwn(differrences, 'repitPeriod')) && differrences['repitPeriod'].after === 5)) {
                setIsOpenWarning(true)
            } else if ((Object.keys(differrences).length === 1) && (Object.hasOwn(differrences, 'runTime'))) {
                setDetailedConfig(false)
            } else {
                setIsOpenWarning(true)
            }
        } else {
            setDetailedConfig(false)
        }
    }

    const declineChanges = () => {
        const differrences: DataObject = differenceOfObjects({ originalObj: templateData, mutableObj: initialState, returnAnswer: 'object'});        
        if (Object.keys(differrences).length > 0) {
            Object.entries(differrences).map((el) => {
                return (
                    updateTemplate(`${el[0]}`, el[1].before)
                )
            })
        }
        setDetailedConfig(false)
        setIsDisabled(true)
    }

    const acceptChanges = () => {
        updateTemplate('interval', intervalInput)
        updateTemplate('repitCount', repeatInput)
        updateTemplate('repitPeriod', 5)
        setPickedOption(5)
        setPeriodIsPicked(true)
        setDetailedConfig(false)
    }

    useEffect(() => {        
        if ((templateData.selectedWeekDays)) {
            const setToArr = templateData.selectedWeekDays.split(',').map(Number)
            const result = arrDotted.filter(el => setToArr.includes(el.id))
            if (result.length) {
                result.forEach(el => {
                    el.isSelected = true
                })
                setArrWeekDays(result)
            }
        }        
    }, [detailedConfig]) // eslint-disable-line react-hooks/exhaustive-deps
    
    const generateMonthDays = () => {
        const initialArr: number[] = arrMonthDays

        let insertPos = 0;
        for (let i = 0; i < initialArr.length; i++) {
        if (initialArr[i] !== 0) {
            initialArr[insertPos] = initialArr[i];
            insertPos++;
        }
        }
        while (insertPos < initialArr.length) {
        initialArr[insertPos] = 0;
        insertPos++;
        }
                
        if ((initialArr.length === 1) && (initialArr.indexOf(0) !== -1)) {
            const arr = initialArr.map((el) => el === 0 ? 'в последний день месяца' : `${el}`)
            return arr.join(', ')
        } else {
            const arr = initialArr.map((el) => el === 0 ? 'и в последний день месяца' : `${el}`)
            return arr.join(', ')
        }
    }

    const generateInfo = () => {
        if (templateData.interval <= 1) {
            if (templateData.intervalType === 0) {
                return `Каждый день `
            }
            if (templateData.intervalType === 1) {
                if ((arrWeekDays.length === 7) && (templateData.interval < 2)) {
                    return `Каждый день`
                } else {
                    return `Каждую неделю `
                }
            }
            if (templateData.intervalType === 2) {
                return `Каждый месяц `
            }
            if (templateData.intervalType === 3) {
                return `Каждый год `
            } 
        }
        if (templateData.interval%10 === 1 && templateData.interval%100 !== 11) {
            if (templateData.intervalType === 0) {
                return `Каждый ${templateData.interval} день `
            }
            if (templateData.intervalType === 1) {
                return `Каждую ${templateData.interval} неделю `
            }
            if (templateData.intervalType === 2) {
                return `Каждый ${templateData.interval} месяц `
            }
            if (templateData.intervalType === 3) {
                return `Каждый ${templateData.interval} год `
            } 
        }else if ((templateData.interval%10 === 2 || templateData.interval%10 === 3 || templateData.interval%10 === 4) &&
            (templateData.interval%100 !== 12 && templateData.interval%100 !== 13 && templateData.interval%100 !== 14)) {
            if (templateData.intervalType === 0) {
                return `Каждые ${templateData.interval} дня `
            }
            if (templateData.intervalType === 1) {
                return `Каждые ${templateData.interval} недели `
            }
            if (templateData.intervalType === 2) {
                return `Каждые ${templateData.interval} месяца `
            }
            if (templateData.intervalType === 3) {
                return `Каждые ${templateData.interval} года `
            }
        } else {
            if (templateData.intervalType === 0) {
                return `Каждые ${templateData.interval} дней `
            }
            if (templateData.intervalType === 1) {
                return `Каждые ${templateData.interval} недель `
            }
            if (templateData.intervalType === 2) {
                return `Каждые ${templateData.interval} месяцев `
            }
            if (templateData.intervalType === 3) {
                return `Каждые ${templateData.interval} лет `
            }
        }
    }
    
    useEffect(() => {
        generateInfo()
        // eslint-disable-next-line
    }, [templateData])
    
    const onBlurInput = (e: any, type: 'interval' | 'repitCount') => {
        if (e.target.value === '') {
            switch (type) {
                case 'interval':
                    setIntervalInput(1)
                    break;
                case 'repitCount':
                    setRepeatInput(1)
                    break
            }
        }
        if (e.target.value > '1') {
            updateTemplate(type, Number(e.target.value))
        }
    }

    const returnedInfoSelect = () => {        
        if (templateData.repitPeriod === 5) {
            if (templateData.intervalType === 1) {
                return (
                    `${generateInfo()}: ${arrWeekDays.map(el => {return `${el.name} `})}`
                )    
            } else if (templateData.intervalType === 2) {
                return (
                    `${generateInfo()}: ${((arrMonthDays.length === 1) && (arrMonthDays[0] === 0)) ? 
                        'в последний день месяца' : arrMonthDays.map(el => {return `${el} `})}`
                )   
            } else {
                return (
                    `${generateInfo()}`
                )
            }
        } else {
            return (
                optionArr[templateData.repitPeriod]?.nameElement ?? 'Не повторять'
            )
        }
    }

    // useEffect(() => {
    //     if (isActive) {
    //         setInitialState(templateData)
    //     }
    //     // eslint-disable-next-line
    // }, [isActive])    

    useEffect(() => {
        setPickedOption(templateData.repitPeriod)
        if (templateData.repitPeriod !== 0) {
            setPeriodIsPicked(true)
        } else {
            setPeriodIsPicked(false)
        }
    }, [templateData.repitPeriod])

    const arrList: CustomListItems[] = [{id: 'never', description: 'Никогда'}, 
    {id: 'date', description: 'Дата', element: <DropDownSelectOfDate dateStart={getDateObject({dateString: templateData.dateEnd})} pickerPosition={windowScreen > 576 ? 'RightCenter' : 'Center'} showIcon={false} getDatePayload={updateTemplateEndDate} />}, 
    {id: 'after', description: 'После', element: <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}><input className='customList__input-container__input' maxLength={3} type="text" value={repeatInput || ''} onChange={(e) => setRepeatInput(Number(e.target.value))} onBlur={(e) => onBlurInput(e, 'repitCount')} /><p>раз</p></div>}];
    const arrList2: CustomListItems[] = [{id: 'createRepeat', description: 'Создавать только после выполнения', element: !isDisabled && settingsUser.isGCalendarIntegrated ? <InfoSVG style={{width: 'auto'}}/> : null}];
    const arrOptionDays: string[] = ['Каждое воскресенье', 'Каждый понедельник', 'Каждый вторник', 'Каждую среду', 'Каждый четверг', 'Каждую пятницу', 'Каждую субботу']
    const arrOptionIntervals: DropDownListArray[] = [{nameElement: 'День'}, 
        {nameElement: 'Неделя'}, 
        {nameElement: 'Месяц'}, 
        {nameElement: 'Год'}]
    const optionArr: DropDownListArray[] =  
    [{nameElement: 'Не повторять', isHidden: viewVariant !== 'EditTask' && viewVariant !== 'default'}, 
        {nameElement: 'Каждый день'}, 
        {nameElement: arrOptionDays[data.getDay()]}, 
        {nameElement: 'Ежемесячно'}, 
        {nameElement: 'По будням'}, 
        {nameElement: 'Хочу по-другому'}]
    
    return (
        <div className='repeatTemplate'>
            {
                viewVariant !== 'EditTask' && 
                <ToolTipComponent autoOpen={alertNullPeriod} active={false} stylesContainer={stylesContainer} stylesList={stylesList} stylesListArrow={stylesListArrow} tooltipHeader='Выберите период повторения' tooltipDescription='Иначе не получится поставить задачу'>
                    <div className={alertNullPeriodIcon ? 'repeatTemplate__btn alert_template' : periodIsPicked ? 'repeatTemplate__btn active_template' : 'repeatTemplate__btn'} title={alertNullPeriod ? '' : 'Повторить задачу'} onClick={(e) => {e.stopPropagation()
                        setIsActive(!isActive)}}>
                        <Logo className={isActive || periodIsPicked ? 'repeatTemplate__btn__icon active__btn' : 'repeatTemplate__btn__icon'}/>
                        <p className='repeatTemplate__btn-descr'>{pickedOption !== null ? optionArr[pickedOption].nameElement : 'Повторять'}</p>
                    </div>
                </ToolTipComponent>
            }
            {
                viewVariant === 'EditTask' &&
                <>
                    <div style={{display: 'flex', gap: '16px', alignItems: 'center', maxWidth: '290px'}}>
                        <div>
                            <LogoModal style={{cursor: 'default'}}/>
                        </div> 
                        <InputSelect onClickFunc={() => setIsActive(!isActive)} isActiveChildren={isActive} addHint={returnedInfoSelect()} title={returnedInfoSelect() ?? 'Не повторять'}/>
                    </div>
                </>
            }
            <DropDown childrenUp={DDprop} onClickFunc={handleSetPeriod} position={windowScreen > 410 ? {} : positionList} isActive={isActive} updateIsActive={setIsActive} optionArr={optionArr} defaultValue={viewVariant === 'EditTask' ? templateData.repitPeriod : pickedOption}/>
            {
                detailedConfig && 
                <ModalWindow freezeEsc={false} dropPaddings={true} disabledCloseBtn={true} position={'center'} modalShow={detailedConfig} updateModalState={() => checkChangesBeforeCloseOutside()}>
                    {
                        isOpenWarning && 
                        <modalWindowContext.Provider value={[isOpenWarning, setIsOpenWarning]}>
                            <ModalWindowSaveChanges modalData={modalData} />
                        </modalWindowContext.Provider>
                    }
                    <div className='detailConfig' ref={refDetailedConfig}>
                        <div className='detailConfig__container' style={{display: "inherit", flexDirection: 'column', gap: '20px', justifyContent: 'center'}}>
                            <div className='detailConfig__heading'>
                                <ArrowCircle />
                                <p>Повторять задачу</p>
                            </div>
                            <div style={{display: 'inherit', flexDirection: 'column', gap: '20px', height:'auto', transition: 'all ease-in 0.3s'}}>
                                <div className='detailConfig__intervalCount'>
                                    <p className='detailConfig__intervalCount-description'>Повторять с интервалом</p>
                                    <div style={{width: '-webkit-fill-available', display: 'flex', justifyContent: 'space-between' }}>
                                        <div className='detailConfig__intervalCount__input'>
                                        <input maxLength={3} 
                                                type="text"
                                                value={intervalInput || ''}  
                                                onChange={(e) => setIntervalInput(Number(e.target.value))}
                                                onBlur={(e) => onBlurInput(e, 'interval')} 
                                                />
                                        </div>
                                    <InputSelect onClickFunc={() => setIsActiveIntervalPick(!isActiveIntervalPick)} isActiveChildren={isActiveIntervalPick} title={arrOptionIntervals[templateData.intervalType]?.nameElement}>
                                        <DropDown defaultValue={templateData.intervalType} isActive={isActiveIntervalPick} updateIsActive={setIsActiveIntervalPick} onClickFunc={updateIntervalPickedVariant} optionArr={arrOptionIntervals}/>
                                    </InputSelect>

                                    </div>
                                </div>
                                {
                                    templateData?.intervalType === 1 && 
                                    <div className={`detailConfig__calendarDotted expanded`}>
                                        <CalendarDotted selectedPayload={arrWeekDays} onSelectedChange={handleSelectedWeekDays}/>
                                    </div>
                                }
                                {
                                    templateData?.intervalType === 2 && 
                                    <div style={{display:'flex', flexDirection: 'column', justifyContent:'center', alignItems: 'center'}} className={`detailConfig_classicCalendar expanded`}>
                                        <OneMonthCalendar selectedPayload={arrMonthDays} onSelectedChange={handleSelectedMonthDays}/>
                                    </div> 
                                }
                                <div className='detailConfig__intervalTime'>
                                    <p className='detailConfig__intervalTime-description'>Время</p>
                                    { detailedConfig && 
                                    <Deadlineinput time={templateData?.templateTime ?? ''} onChangeFunc={updateTimeTask}/> } 
                                </div>
                                <div className='deatilConfig__otherParams'>
                                    <div className='detailConfig__otherParamsContainer' onClick={() => setIsDisabled(!isDisabled)} style={ isDisabled ? {color: '#6B7280'} : {color: '#232360'}}>Другие параметры <Arrow className='' style={isDisabled ? {transform: 'rotateZ(90deg)' } : {transform: 'rotateZ(0deg)'}}/></div>
                        
                                    <p style={isDisabled ? {display: 'none'} : {display: 'block', color: '#6B7280', fontSize: '12px', lineHeight: '12px', marginLeft: '16px'}}>Окончание</p>
                                    <div style={{marginLeft: '16px', maxWidth: '176px'}}>
                                        <CustomList defaultCheck={templateData.endType} 
                                            onChangeFunc={(index: number) => updateEndTypeVariant(index)} 
                                            list={arrList} 
                                            listName='list' 
                                            hide={isDisabled} 
                                            listVariant="radio" />
                                    </div>
                                    <div style={{marginLeft: '16px'}}>
                                        <ToolTipComponent tooltipHeader={"Важно"}
                                            tooltipDescription={"Не работает в Google Календарь, увы"} 
                                            stylesList={stylesListInfo} 
                                            stylesListArrow={stylesListArrowInfo}
                                            active={settingsUser.isGCalendarIntegrated}>
                                            <CustomList onChangeFunc={(isCheck: boolean) => updateTemplate('isCreatedAfterCompited', isCheck)} 
                                                list={arrList2}
                                                defaultCheck={templateData.isCreatedAfterCompited}
                                                listName='list'  
                                                listVariant="checkbox" 
                                                hide={isDisabled}/>                
                                        </ToolTipComponent>
                                    </div>
                                </div>
                                    <div className='detailConfig__resultContainer'
                                        style={!isDisabled ? {marginTop: '16px'} : {marginTop: '-16px'}}>
                                        <div>
                                            <Info style={{marginRight: '8px'}}/>
                                        </div>
                                        <p style={{lineHeight: 'normal'}}>{`${generateInfo()} ${arrWeekDays.length === 7 ? templateData.interval < 2 ? `` : ` каждый день` : arrWeekDays.length >= 1 ? `в ${arrWeekDays.map(el => {return ` ${el.name}`})}` : ''}`} {generateMonthDays()} {templateData.templateTime && ` в ${templateData.templateTime}`}</p>
                                    </div>                            
                            </div>
                                <div style={{display: 'flex', gap: '12px', flexDirection: 'row', justifyContent: 'flex-end'}}>
                                    <Button title='Отмена' btnType="default" btnSize="base" onClickFunc={() => declineChanges()}/>
                                    <Button title='Повторять' btnType="filled" btnSize="base" onClickFunc={() => acceptChanges()}/>
                                </div>
                        </div>
                    </div>
                </ModalWindow>
            }
        </div>
    )
}


export default DDSelectRepeatTemplate;